import { localStorageInstance } from '@gem/modules/storage';
import { parseJSON } from '@gem/utils';

import { IDiscoverDestination } from 'APP/model/tenantRouter/tenantRouterModel.types';
import {
  createDiscoverDestinationWithKey,
  IDiscoverDestinationWithoutKey,
} from 'UTILS/discoverDestinationsUtils';

const DISCOVER_DESTINATIONS_STORAGE_KEY = 'discover-destinations';

function getUserDiscoverDestinationsStorageKey(email: string): string {
  return `${DISCOVER_DESTINATIONS_STORAGE_KEY}-${email}`;
}

export function set(email: string, destinations: IDiscoverDestination[]): void {
  const storageKey = getUserDiscoverDestinationsStorageKey(email);

  try {
    const destinationsString = JSON.stringify(destinations) || '';
    localStorageInstance.setItem(storageKey, destinationsString);
  } catch {
    localStorageInstance.setItem(storageKey, '');
  }
}

export function get(email: string): IDiscoverDestination[] {
  const data = localStorageInstance.getItem(getUserDiscoverDestinationsStorageKey(email));
  if (!data) {
    return [];
  }

  return parseJSON<IDiscoverDestination[]>(data) || [];
}

export function add(
  email: string,
  destination: IDiscoverDestinationWithoutKey
): IDiscoverDestination {
  const destinations = get(email);
  const destinationWithKey = createDiscoverDestinationWithKey({ ...destination, isLocal: true });
  let isDestinationSaved = false;
  const newDestinations = destinations.map((item) => {
    if (item.key === destinationWithKey.key) {
      isDestinationSaved = true;
      return destinationWithKey;
    }
    return item;
  });

  if (!isDestinationSaved) {
    newDestinations.push(destinationWithKey);
  }

  set(email, newDestinations);
  return destinationWithKey;
}

export function remove(email: string): void {
  localStorageInstance.removeItem(getUserDiscoverDestinationsStorageKey(email));
}
